import React, { useState } from 'react';
import { Button, Dialog, TextField } from '@mui/material';
interface CreateCategory {
  open: boolean;
  handleClose: () => void;
  handleCreate: (data: any) => void;
  categoryId: string;
  categortText: string;
}
const CreatePopup: React.FC<CreateCategory> = ({
  open,
  handleClose,
  handleCreate,
  categoryId,
  categortText,
}) => {
  const [categoryName, setCategoryName] = useState('');
  const handleCreateCategory = () => {
    let payload = {};
    if (categoryId?.trim().length > 0) {
      payload = {
        categoryID: categoryId,
        subCategoryName: categoryName,
      };
    } else {
      payload = {
        categoryName: categoryName,
      };
    }
    handleCreate(payload);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      className="create_category-popup"
    >
      <div className="create_category-popup-container">
        <div className="create_category-popup_conetent-heading">
          <h4>Add New {categortText}</h4>
        </div>
        <div className="create_category-popup-container-form">
          <h3>{categortText} Name</h3>
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            placeholder="Enter Name"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
          />
        </div>
        <div className="create_category-popup-container-btns">
          <Button
            onClick={handleClose}
            className="create_category_cancel_btn"
            variant="contained"
          >
            Cancel
          </Button>
          <Button
            onClick={handleCreateCategory}
            variant="contained"
            className={
              categoryName?.trim() !== ''
                ? 'create_category_save_btn'
                : 'create_category_save_btn disable_button'
            }
            disabled={categoryName?.trim() === '' ? true : false}
          >
            Save
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

const MemoizedComponent = React.memo(CreatePopup);
export default MemoizedComponent;
